import { Component, Input } from '@angular/core';
import { PATHS } from 'shared/paths';
import { Image } from 'shared/types';
import { PanelType, TopTab } from './button-detail-list-larger.types';

type TabOrientation = 'horizontal' | 'vertical';

@Component({
    selector: 'button-detail-list-larger',
    templateUrl: './button-detail-list-larger.component.html',
    styleUrls: ['./button-detail-list-larger.component.scss'],
})
export class ButtonDetailListLargerComponent {
    @Input() tabs: TopTab[] = [];
    @Input() hideTabs = false;
    @Input() accountsTitle?: string;
    @Input() mobileModalClass = '';

    public readonly imgPath = PATHS.articleImages;
    public readonly panelType = PanelType;
    public tabIndex = 0; // top tab index
    public stIndex = 0; // left tab current index (sub)
    public sstIndex = -1; // right tab index (sub sub)

    onTabClick(i: number): void {
        this.tabIndex = i;
        this.stIndex = 0;
        this.sstIndex = -1;
    }

    onSubTabClick(i: number): void {
        this.stIndex = i;
        this.sstIndex = -1;
    }

    onTopTabKeydown(event: KeyboardEvent, currentIndex: number): void {
        const nextIndex = this.nextTabIndex(event.key, currentIndex, this.tabs.length, 'horizontal');

        if (nextIndex === undefined) {
            return;
        }

        event.preventDefault();
        this.onTabClick(nextIndex);
        this.focusTabControl(`diag-panel-control${nextIndex}`);
    }

    onSubTabKeydown(event: KeyboardEvent, topTabIndex: number, currentIndex: number, itemCount: number): void {
        const nextIndex = this.nextTabIndex(event.key, currentIndex, itemCount, 'vertical');

        if (nextIndex === undefined) {
            return;
        }

        event.preventDefault();
        this.onSubTabClick(nextIndex);
        this.focusTabControl(`diag-pill-control${topTabIndex}-${nextIndex}`);
    }

    imageUrl(image?: Image, width = 800): string {
        return image?.url ? `${this.imgPath}${image.url}-${width}.webp` : '';
    }

    toggleSubSub(i: number): void {
        this.sstIndex = this.sstIndex === i ? -1 : i;
    }

    private nextTabIndex(key: string, currentIndex: number, itemCount: number, orientation: TabOrientation): number | undefined {
        if (itemCount < 1) {
            return undefined;
        }

        if (key === 'Home') {
            return 0;
        }

        if (key === 'End') {
            return itemCount - 1;
        }

        if (orientation === 'horizontal') {
            if (key === 'ArrowRight') {
                return (currentIndex + 1) % itemCount;
            }

            if (key === 'ArrowLeft') {
                return (currentIndex - 1 + itemCount) % itemCount;
            }
        }

        if (orientation === 'vertical') {
            if (key === 'ArrowDown') {
                return (currentIndex + 1) % itemCount;
            }

            if (key === 'ArrowUp') {
                return (currentIndex - 1 + itemCount) % itemCount;
            }
        }

        return undefined;
    }

    private focusTabControl(controlId: string): void {
        document.getElementById(controlId)?.focus();
    }
}
